import React from 'react';
import { createUseStyles } from 'react-jss';
import { S, TONES, Tone } from './tokens';

type Props = {
  tone: Tone;
  label: string;
  /** Longer explanation, shown on hover. */
  title?: string;
  className?: string;
};

const useStyles = createUseStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    height: 22,
    padding: '0 8px 0 7px',
    borderRadius: 11,
    fontFamily: S.ui,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: 'nowrap'
  },
  dot: { width: 6, height: 6, borderRadius: '50%', flexShrink: 0 }
});

/** A status lamp: colored dot and a short label. */
const StatusBadge: React.FC<Props> = ({ tone, label, title, className }) => {
  const c = useStyles();
  const t = TONES[tone] || TONES.gray;
  return (
    <span className={[c.badge, className].filter(Boolean).join(' ')} style={{ color: t.fg, background: t.bg }} title={title} data-tone={tone}>
      <span className={c.dot} style={{ background: t.dot }} aria-hidden />
      {label}
    </span>
  );
};

export default StatusBadge;
